// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/layout.css
// module id = Bko/
// module chunks = 1